(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('shopify:block:select',event=>{
  const models=event.target.closest('.product-models');
  if(models)models.open=true;
});

  } catch(e) { console.error(e); }
})();
})();
